<template>
    <div class="table_wrap">
        <el-table class="list-table" header-cell-class-name="list-header" :data="streamingData"
                  :row-class-name="toggleCheckClass" style="width: 100%;" height="695" empty-text="데이터가 없습니다."
                  @selection-change="tableSelectChange">
            <el-table-column
                    type="selection"
                    class-name="text-center"
                    min-width="25">
            </el-table-column>
            <el-table-column
                    class="table_no"
                    type="index"
                    label="No"
                    min-width="70"
                    class-name="num text-center"
                    :index="tableIdx"
            >
            </el-table-column>
            <el-table-column label="아이디 유형" width="" class-name="text-center">
                <template slot-scope="scope">
                    <span>
                        {{checkMemberType(scope.row.type)}}
                    </span>
                </template>
            </el-table-column>
            <el-table-column label="아이디" width="" class-name="text-center" prop="mb_id"></el-table-column>
            <el-table-column label="닉네임" width="" class-name="text-center" prop="mb_nick"></el-table-column>
            <el-table-column label="결제 KOIN" width="" class-name="text-center" prop="Koin"></el-table-column>
            <el-table-column
                    label="회원가입일" min-width="" class-name="text-center">
                <template slot-scope="scope">
                    <span>
                        {{ returnDateFormat(scope.row.join_date) }}
                    </span>
                </template>
            </el-table-column>
            <el-table-column
                label="결제일" min-width="" class-name="text-center">
                <template slot-scope="scope">
                    <span>
                        {{ returnDateFormat(scope.row.pay_date) }}
                    </span>
                </template>
            </el-table-column>
            <el-table-column
                    label="옵션" width="85" class-name="text-center">
                <template slot-scope="scope">
                    <div class="row-info">
                        <el-button @click="goProfile(scope.row.mb_no)">
                            상세
                        </el-button>
                    </div>
                </template>
            </el-table-column>
        </el-table>
    </div>
</template>

<script>
import util from "@/mixins/util";
import EventBus from "@/utils/event-bus";
import dateMixins from "@/mixins/dateMixins";
import memberUtil from "@/components/member/memberUtil";

export default {
    name: "StreamingListStudentLayout",
    mixins: [dateMixins, memberUtil],
    inject: ['streamingListSetData'],
    components: {},
    provide() {
        return {}
    },
    props: {
        streamingData: {default: () => []},
        paginationData: {
            default: () => {
                return {total: 0, page: 0, size: 0,}
            }
        },
    },
    data() {
        return {
            selectArr: [],
        }
    },
    created() {
    },
    mounted() {
    },
    beforeDestroy() {
    },
    destroyed() {
    },
    computed: {},
    methods: {
        tableSelectChange(row) {
            this.selectArr = [];
            util.Array.each(row, (obj, index, arr) => {
                this.selectArr.push(obj.mb_no);
            });
            this.streamingListSetData('selectArr', this.selectArr)
        },
        // 선택된 로우만 클래스 추가/제거 로직
        toggleCheckClass({row, rowIndex}) {
            return this.selectArr.indexOf(row.bb_idx) > -1 ? 'select' : '';
        },
        tableIdx(index) {
            return this.paginationData.total - index - (this.paginationData.page - 1) * this.paginationData.size;
        },
        goProfile(idx) {
            this.$router.push(`/student/member/${idx}`);

        },
        runPenalty(idx) {
            this.declarationListAddPenalty(idx)
        },
        checkMemberType(social){
            if(social === 'Email'){

                return this.returnMemberType(social)
            }
            else {
                return this.returnMemberType(social.social_type)

            }
        },
    },
    watch: {},
}
</script>

<style scoped>

</style>
